type ActionMap<M extends {[index: string]: any}> = {
    [Key in keyof M]: M[Key] extends undefined
    ? {
        type: Key;
    }
    : {
        type: Key;
        payload: M[Key];
    }
}

export enum StoreActionKeys {
    SetMobile = 'SET_MOBILE',
    SetMode = 'SET_MODE',
    SetSideBar = 'SET_SIDE_BAR',
    ResetState = 'RESET_STATE'
}

type StorePayload = {
    [StoreActionKeys.SetMode]: 'light' | 'dark';
    [StoreActionKeys.SetSideBar]: boolean;
    [StoreActionKeys.SetMobile]: boolean;
    [StoreActionKeys.ResetState]: undefined;
}

export type StoreActionMap = ActionMap<StorePayload>[keyof ActionMap<StorePayload>];

export type StoreActions = {
    resetState: () => StoreActionMap;
    setMode: (mode: 'light' | 'dark') => StoreActionMap;
    setSideBar: (open: boolean) => StoreActionMap;
    setMobile: (value: boolean) => StoreActionMap;
}

export const storeActions: StoreActions = {
    resetState: () => ({
        type: StoreActionKeys.ResetState
    }),
    setMode: (mode: 'light' | 'dark') => ({
        type: StoreActionKeys.SetMode,
        payload: mode
    }),
    setSideBar: (open: boolean) => ({
        type: StoreActionKeys.SetSideBar,
        payload: open
    }),
    setMobile: (value: boolean) => ({
        type: StoreActionKeys.SetMobile,
        payload: value
    })
};